import axios from 'axios';

import { API_BASE_URL } from '../config';

const source = axios.CancelToken.source();

const instance = axios.create({
  baseURL: API_BASE_URL,
  cancelToken: source.token,
});

export default instance;
